<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-12">
               <h1 class="pull-left">
                  Campaign Sale reports
               </h1>
               <div class="pull-right">
                  <a href="#" class="btn" style="background-color: #526883; color: white; display: none;"><i class="fa fa-cloud-download" style="font-size: 16px;"></i> Download All</a>
               </div>
            </div>
         </div>
      </section>
      <section class="content">
         <form v-on:submit.prevent="searchReportData">
         <div class="row">
            <div class="col-xs-6 col-sm-2">
               <div class="form-group">
                  <filterDropdownOptions />
               </div>
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="From" type="text" value="" name="starttime" id="starttime" v-model="starttime" autocomplete="off" class="form-control input-sm datePicker">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="To" type="text" value="" name="stoptime" id="stoptime" v-model="stoptime" class="form-control input-sm datePicker" autocomplete="off">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="coupon_code" id="coupon_code" v-model="coupon_code" v-select="coupon_code" class="form-control input-sm select2" @change="searchReportData">
                  <option value="">All Coupon Codes</option>
                  <option v-for="(data, index) in coupon_list" :key="index" :value="data.id">{{data.coupon_code}}</option>
               </select>
            </div>
            <div class="row">
               <div class="col-xs-6 col-sm-2 form-group">
                  <input placeholder="Search By Subscription" type="text" name="login" id="login" v-model="login" class="form-control input-sm" value="">
               </div>
            </div>
            <div id="btnSearch" class="col-xs-6 col-sm-2 pull-right form-group  btnLeft" style="margin-bottom: 5px">
               <button type="submit" class="btn btn-sm btn-submit pull-right">
                  <i class="fa fa-search"></i> Search
               </button>
            </div>
         </div>
         </form>
         <div class="row">
            <div class="col-md-12">
               <div class="box" id="pagination">
                  <div class="box-header">
                     <h3 class="box-title">
                        Total {{listArr.length}} Row Found
                     </h3>
                  </div>
                  <div class="box-body">
                     <div class="table-responsive">
                        <table class="table table-0024 table-bordered table-striped">
                           <thead>
                              <tr>
                                 <th class="tdCenter tdSN">SN</th>
                                 <th class="tdCenter">Subscription</th>
                                 <th class="tdCenter">Sale Date</th>
                                 <th class="tdCenter">Plan</th>
                                 <th class="tdCenter">Coupon Code</th>
                                 <th class="tdCenter">Discount</th>
                                 <th class="tdCenter">Selling Price</th>
                                 <th class="tdCenter">Aff Share (%)</th>
                                 <th class="tdCenter">Aff Share Amnt</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="(data, index) in listArr" :key="data.id">
                                 <td class="tdCenter tdSN">
                                    {{parseInt(++index)}}
                                 </td>
                                 <td class="tdCenter  ">
                                    {{data.username}}
                                 </td>
                                 <td class="tdCenter  ">
                                    {{data.tran_time}}
                                 </td>
                                 <td class="tdCenter">
                                    {{data.name}}
                                 </td>
                                 <td class="tdCenter">
                                    {{data.coupon_code}}
                                 </td>
                                 <td class="tdCenter">
                                    {{data.discount}}
                                 </td>
                                 <td class="tdRight info">
                                    <span>{{data.total_amount}}</span>
                                 </td>
                                 <td class="tdCenter info">
                                    {{data.aff_share}} %
                                 </td>
                                 <td class="tdRight info">
                                    {{data.aff_share_amnt}}
                                 </td>
                             </tr>
                              <tr v-if="listArr.length==0">
                                 <td colspan="11" class="tdCenter" style="padding: 30px 0;"><b>No Records  Found</b></td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
                  <div class="table-responsive">
                     <table class="table table-middle-small table-bordered">
                        <thead>
                           <tr>
                              <th class="tdCenter">Total Records</th>
                              <th class="tdCenter">Total Sale Amount</th>
                              <th class="tdCenter">My Total Share</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td class="success">{{listArr.length}}</td>
                              <td class="info">
                                 {{total_last_retail_payment}}
                              </td>
                              <td class="success">
                                 {{my_total_share}}
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
      </section>
   </div>
</template>
<script>
   import filterDropdownOptions from "@/components/common/filterDropdownOptions.vue";
   import axios from 'axios'
   export default {
      name: "CampaignSaleReport",
      components: {
         filterDropdownOptions,
      },
      data() {
         return {
            listArr : [],
            userData : {},
            coupon_list : {},
            coupon_code : '',
            starttime : '',
            stoptime : '',
            login : '',
            userlevel:'',
            total_last_retail_payment : 0,
            my_total_share : 0,
         }
      },
      created(){
         this.com_user_type_access([1,2], true);
         //Get User Level from user store
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         var userData = JSON.parse(decodedString);
         this.userData = userData;
         this.userlevel = userData.user_level;
         // End

         var rootObject = this;
         loader.show();
         axios.get('affiliate/campaign-coupons').then(function (response) {
            rootObject.coupon_list = response.data.couponList.data;
            //console.log(response.data.couponList);
         })
         .catch(function (error) {
            let alertmessage = "";
            for (var prop in error.response.data) {
               alertmessage += ' '+error.response.data[prop]
            }
            console.log(alertmessage); 
            rootObject.com_errorHandel(error);
         });

         this.filterWiseDateRangeSet();
         this.searchReportData();
      },
      methods: {

         searchReportData(){
            loader.show();
            var rootObject = this;

            const form = new FormData()
            form.append('fromDate', this.starttime)
            form.append('toDate', this.stoptime)
            form.append('login', this.login)
            form.append('campaign_coupon_id', this.coupon_code)
            form.append('short_filter', $("#short_filter").val());
   
            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }
   
            axios.post('reports/affiliate-sale-report', form, config).then(function (response) {
               //console.log(response);
               rootObject.populateReportData(response);
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },
   
         populateReportData(response){
            var rootObject = this;
            var total_last_retail_payment = 0;
            var my_total_share = 0;
      
            this.listArr = [];
            this.total_last_retail_payment = 0;
            this.my_total_share = 0;
            this.return_count = 0;

            var coupon_arr = response.data.data.coupon_arr;
            //console.log(coupon_arr);

            for (var prop in response.data.data.pinData) {

               total_last_retail_payment = parseFloat(total_last_retail_payment) + parseFloat(response.data.data.pinData[prop]['total_amount']);

               var couponID = response.data.data.pinData[prop]['campaign_coupon_id'];
               var rate_plan_detail_id = response.data.data.pinData[prop]['plan_details_id'];
               response.data.data.pinData[prop]['coupon_code'] = coupon_arr[couponID]['coupon_code'];
               if(coupon_arr[couponID][rate_plan_detail_id]['discount_type']==1){
                  response.data.data.pinData[prop]['discount'] = '$'+coupon_arr[couponID][rate_plan_detail_id]['discount_amount'];   
               }else{
                  response.data.data.pinData[prop]['discount']= coupon_arr[couponID][rate_plan_detail_id]['discount_amount']+'%';
               }
               
               response.data.data.pinData[prop]['aff_share'] = coupon_arr[couponID]['affiliate_share_percent'];

               response.data.data.pinData[prop]['aff_share_amnt'] = ((response.data.data.pinData[prop]['total_amount'] * response.data.data.pinData[prop]['aff_share'])/100).toFixed(2);
               my_total_share = parseFloat(my_total_share) + parseFloat(response.data.data.pinData[prop]['aff_share_amnt'])
               this.listArr.push(response.data.data.pinData[prop]);
            }
   
            this.my_total_share = my_total_share.toFixed(2);
            this.total_last_retail_payment = total_last_retail_payment.toFixed(2);
            loader.hide();
         },
   
         filterWiseDateRangeSet()
         {
            $(".datePicker").removeAttr('readonly', 'readonly'); 
            if ($("#short_filter").val()) {
               this.starttime = '';
               this.stoptime = '';
               $(".datePicker").attr('readonly', 'readonly'); 
            }else{
               var dateRangeArr = this.com_currentDateRange();
               this.starttime = dateRangeArr.startDate;
               this.stoptime = dateRangeArr.endDate;
            }
         },

         getFormattedTime() {
            var today = new Date();
            var y = today.getFullYear();
            var m = today.getMonth() + 1;
            var d = today.getDate();
            return y + "-" + m + "-" + d;
         }
         
      },
      mounted: function() {
         var rootObject = this;
         $('#starttime').datetimepicker({
            timepicker: false,
            format: 'Y-m-d'
         }).on('change', function(e){
            rootObject.starttime = $(this).val();
         });

         $('#stoptime').datetimepicker({
            timepicker: false,
            format: 'Y-m-d'
         }).on('change', function(e){
            rootObject.stoptime = $(this).val();
         });

         $("#short_filter").on('change', function(){
            rootObject.filterWiseDateRangeSet();
            rootObject.searchReportData();
         });
   
         $(".select2").select2();
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>